import React, { useState, useEffect } from "react";
import {
  TextField,
  IconButton,
  FormControl,
  FormHelperText,
} from "@mui/material";
import { CloudUpload as CloudUploadIcon } from "@mui/icons-material";

const FileUpload = ({
  label,
  name,
  onChange,
  error,
  helperText,
  accept = "image/*,application/pdf",
  multiple = false,
  defaultFileName = "No file chosen",
}) => {
  const [fileName, setFileName] = useState(defaultFileName);

  useEffect(() => {
    setFileName(defaultFileName);
  }, [defaultFileName]);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setFileName(file.name);
      if (onChange) onChange(event);
    }
  };

  return (
    <FormControl error={error} sx={{ minWidth: 300 }}>
      <TextField
        label={label}
        name={name}
        type="text"
        value={fileName}
        className="mb-2"
        size="small"
        InputProps={{
          readOnly: true,
          endAdornment: (
            <IconButton component="label" style={{ padding: 0 }}>
              <CloudUploadIcon />
              <input
                type="file"
                name={name}
                hidden
                onChange={handleFileChange}
                accept={accept}
                multiple={multiple}
              />
            </IconButton>
          ),
        }}
      />
      {error && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

export default FileUpload;